<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <!-- Logo -->
        <div class="logo">
          <router-link to="/" class="logo-link">
            <img src="@/assets/images/IPZhiXin.png" alt="IPZhiXin Logo" class="logo-image">
          </router-link>
        </div>

        <!-- 桌面导航 -->
        <nav class="nav-desktop">
          <ul class="nav-list">
            <li class="nav-item">
              <router-link to="/" class="nav-link" exact-active-class="active" exact>
                之于行概览
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/company-intro" class="nav-link" active-class="active">
                公司简介
              </router-link>
            </li>
            <li class="nav-item" @mouseenter="showTeamDropdown = true" @mouseleave="showTeamDropdown = false">
              <router-link to="/team" class="nav-link" active-class="active">
                团队
              </router-link>
              <div class="team-dropdowna" v-show="showTeamDropdown">
                <div class="team-members">
                  <div class="team-member" 
                       v-for="(member, index) in teamMembers" 
                       :key="index"
                       @click="goToTeamPage"
                       @mouseenter="hoveredMember = index"
                       @mouseleave="hoveredMember = null">
                    <div class="member-image">
                      <img :src="require(`@/${member.image}`)" :alt="member.name">
                    </div>
                    <div class="member-info">
                      <h3 class="member-name" :class="{'hovered': hoveredMember === index}">{{ member.name }}</h3>
                      <p class="member-education" 
                         v-for="(edu, eduIndex) in member.education" 
                         :key="eduIndex"
                         :class="{'hovered': hoveredMember === index}">{{ edu }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="nav-item" @mouseenter="showServicesDropdown = true" @mouseleave="showServicesDropdown = false">
              <router-link to="/practice-areas" class="nav-link" active-class="active">
                服务范围
              </router-link>
              <div class="team-dropdown" v-show="showServicesDropdown">
                <div class="team-members">
                  <div class="team-member" 
                       v-for="(service, index) in services" 
                       :key="index"
                       @click="goToPracticeAreasPage"
                       @mouseenter="hoveredService = index"
                       @mouseleave="hoveredService = null">
                    <div class="member-image">
                      <img :src="require(`@/${service.image}`)" :alt="service.name">
                    </div>
                    <div class="member-info">
                      <h3 class="member-name" :class="{'hovered': hoveredService === index}">{{ service.name }}</h3>
                      <p class="member-education" 
                         v-for="(edu, eduIndex) in service.education" 
                         :key="eduIndex"
                         :class="{'hovered': hoveredService === index}">{{ edu }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="nav-item">
              <router-link to="/expertise-areas" class="nav-link" active-class="active">
                专业领域
              </router-link>
            </li>
            <li class="nav-item" @mouseenter="showNewsDropdown = true" @mouseleave="showNewsDropdown = false">
              <router-link to="/news" class="nav-link" active-class="active">
               动态资讯
              </router-link>
              <div class="news-dropdown" v-show="showNewsDropdown">
                <div class="news-menu">
                  <div class="news-menu-item" @click="goToNewsPage('/news')">
                    <div class="menu-item-content">
                      <h3 class="menu-item-title">智见要闻</h3>
                      <p class="menu-item-desc">最新行业资讯和公司动态</p>
                    </div>
                  </div>
                  <div class="news-menu-item" @click="goToNewsPage('/hangye-news')">
                    <div class="menu-item-content">
                      <h3 class="menu-item-title">行业活动</h3>
                      <p class="menu-item-desc">行业会议、展览和活动信息</p>
                    </div>
                  </div>
                  <div class="news-menu-item" @click="goToNewsPage('/huikui-news')">
                    <div class="menu-item-content">
                      <h3 class="menu-item-title">回馈社会</h3>
                      <p class="menu-item-desc">公益活动和社会责任实践</p>
                    </div>
                  </div>
                  <div class="news-menu-item" @click="goToNewsPage('/xiaoqi-news')">
                    <div class="menu-item-content">
                      <h3 class="menu-item-title">校企合作</h3>
                      <p class="menu-item-desc">与高校的合作项目和成果</p>
                    </div>
                  </div>
                </div>
              </div>
            </li>


            <li class="nav-item">
              <router-link to="/contact" class="nav-link" active-class="active">
                联系我们
              </router-link>
            </li>
          </ul>
        </nav>

        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>

    <!-- 移动端导航 -->
    <nav class="nav-mobile" v-show="mobileMenuOpen">
      <ul class="nav-mobile-list">
        <li class="nav-mobile-item">
          <router-link to="/" tag="a" class="nav-mobile-link" exact-active-class="active" exact @click.native="closeMobileMenu">
            公司概览
          </router-link>
        </li>
        <li class="nav-mobile-item">
          <router-link to="/company-intro" tag="a" class="nav-mobile-link" active-class="active" @click.native="closeMobileMenu">
            公司简介
          </router-link>
        </li>
            <li class="nav-mobile-item">
          <router-link to="/team" tag="a" class="nav-mobile-link" active-class="active" @click.native="closeMobileMenu">
            团队
          </router-link>
        </li>
         <li class="nav-mobile-item">
          <router-link to="/practice-areas" tag="a" class="nav-mobile-link" active-class="active" @click.native="closeMobileMenu">
            服务
          </router-link>
        </li>
        <li class="nav-mobile-item">
          <router-link to="/expertise-areas" tag="a" class="nav-mobile-link" active-class="active" @click.native="closeMobileMenu">
            专业领域
          </router-link>
        </li>
        <li class="nav-mobile-item">
          <router-link to="/news" tag="a" class="nav-mobile-link" active-class="active" @click.native="closeMobileMenu">
            新闻报道
          </router-link>
        </li>
        <li class="nav-mobile-item">
          <router-link to="/contact" tag="a" class="nav-mobile-link" active-class="active" @click.native="closeMobileMenu">
            联系我们
          </router-link>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      mobileMenuOpen: false,
      showTeamDropdown: false,
      hoveredMember: null,
      showServicesDropdown: false,
      hoveredService: null,
      showNewsDropdown: false,
      services: [{
          name: '专利服务',
          education: [
            '专利挖掘服务、专利申请服务、审查及复审服务'
          ],
          image: 'assets/images/s_zhuanli.png'
        },
        {
          name: '商标及著作权',
          education: [
            '商标、集成电路布图设计及著作权登记、商标申请服务、答辩及近似检索服务'
          ],
          image: 'assets/images/s_shangbiao.png'
        },
        {
          name: '商业秘密',
          education: [
            '基于销售额的分级策、基于技术难度的分级策略'
          ],
          image: 'assets/images/s_shangye.png'
        },
        {
          name: '侵权维权',
          education: [
            '侵权应对、被控侵权的应对',
            '保护范围分析、权利稳定性分析'
          ],
          image: 'assets/images/s_qinquan.png'
        }
      ],
      teamMembers: [
        {
          name: '专利团队',
          education: [
              // '商标的注册咨询、商标查询',
              //  '商标权的转让、许可、变更、续展等',
              // '代理商标侵权诉讼、权属纠纷相关业务',
              // '担任商标法律顾问',
              // '注册商标的跟踪监控',
          ],
          image: 'assets/images/teamimg/zhuanliimg.png'
        },
         {
          name: '商标团队',
          education: [
              // '商标的注册咨询、商标查询',
              //  '商标权的转让、许可、变更、续展等',
              // '代理商标侵权诉讼、权属纠纷相关业务',
              // '担任商标法律顾问',
              // '注册商标的跟踪监控',
          ],
          image: 'assets/images/teamimg/shangbiaoteam.png'
        },
        {
          name: '涉外团队',
          education: [
            //'程曦、徐畅、江赞多、汤昱茹、吴玉婷'
          ],
          image: 'assets/images/teamimg/shewaiimg.png'
        },
        {
          name: '翻译团队',
          education: [
        //    '廖青川、江函育、孙梦璇、尤佳、杨欣怡、来晓黎'
          ],
          image: 'assets/images/teamimg/fanyiimg.png'
        },
        {
          name: '流程团队',
          education: [
            //'温仁清、李小兰、侯海琼、黄裕如、汤鑫、庞娟',
            ''
          ],
          image: 'assets/images/teamimg/liuchengimg.png'
        }
      ]
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
    },
    goToTeamPage() {
      if (this.$route.path !== '/team') {
        this.$router.push('/team')
      }
      this.showTeamDropdown = false
    },
    goToPracticeAreasPage() {
      if (this.$route.path !== '/practice-areas') {
        this.$router.push('/practice-areas')
      }
      this.showServicesDropdown = false
    },
    goToNewsPage(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
      this.showNewsDropdown = false
    }
  }
}
</script>

<style scoped>
.header {
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

/* Logo样式 */
.logo {
  flex: 0 0 auto;
}

.logo-link {
  font-size: 1.8rem;
  font-weight: 700;
  text-decoration: none;
  color: #333;
  transition: color 0.3s ease;
}

.logo-link:hover {
  color: #FF631E;
}

.logo-link .highlight {
  color: #FF631E;
}

.logo-image {
  height: 60px;
  width: 168px;
  transition: opacity 0.3s ease;
}

.logo-link:hover .logo-image {
  opacity: 0.8;
}

/* 桌面导航样式 */
.nav-desktop {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.nav-list {
  display: flex;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  margin: 0;
}

.nav-link {
  display: block;
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  padding: 0.5rem 0;
  position: relative;
  transition: color 0.3s ease;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: #FF631E;
  transition: width 0.3s ease, left 0.3s ease;
}

.nav-link:hover {
  color: #FF631E;
}

.nav-link:hover::after {
  width: 100%;
  left: 0;
}

.nav-link.active {
  color: #FF631E
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #FF631E;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #333;
  cursor: pointer;
}

.mobile-menu-btn i {
  font-size: 1.5rem;
}

/* 移动端导航样式 */
.nav-mobile {
  background-color: white;
  border-top: 1px solid #e9ecef;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}

.nav-mobile-list {
  list-style: none;
  margin: 0;
  padding: 1rem 0;
}

.nav-mobile-item {
  margin: 0;
}

.nav-mobile-link {
  display: block;
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  padding: 1rem 2rem;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.nav-mobile-link:hover {
  background-color: #f8f9fa;
  color: #FF631E;
}

.nav-mobile-link.active {
  background-color: #f8f9fa;
  color: #FF631E;
}

/* 团队下拉菜单样式 */
.nav-item {
  position: relative;
}

.team-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  height: 550px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  padding: 20px;
  z-index: 1001;
  overflow-y: hide;
  margin-top: 10px;
  
}
.team-dropdowna {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  height: 686px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  padding: 20px;
  z-index: 1001;
  overflow-y: hide;
  margin-top: 10px;
  
}
.team-dropdowna::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}
.team-dropdown::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}

.team-members {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.team-member {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.team-member:hover {
  background-color: #f9f9f9;
}

.team-member:last-child {
  border-bottom: none;
}

.member-image {
  width: 60px;
  height: 80px;
  /* border-radius: 50%; */
  overflow: hidden;
  margin-right: 15px;
  flex-shrink: 0;
}

.member-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.member-info {
  flex: 1;
}

.member-name {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #333;
  transition: color 0.3s ease;
}

.member-name.hovered {
  color: #FF631E;
}

.member-education {
  font-size: 0.9rem;
  color: #666;
  margin: 4px 0;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.member-education.hovered {
  color: #FF631E;
}

/* 新闻下拉菜单样式 */
.news-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 320px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  padding: 15px;
  z-index: 1001;
  margin-top: 10px;
}

.news-dropdown::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}

.news-menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.news-menu-item {
  padding: 12px 15px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-left: 3px solid transparent;
}

.news-menu-item:hover {
  background-color: #f8f9fa;
  border-left-color: #FF631E;
}

.menu-item-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.menu-item-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: #333;
  transition: color 0.3s ease;
}

.news-menu-item:hover .menu-item-title {
  color: #FF631E;
}

.menu-item-desc {
  font-size: 0.85rem;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
  
  .team-dropdown {
    width: 350px;
  }
    .team-dropdowna {
    width: 350px;
  }
}

@media (max-width: 992px) {
  .nav-desktop {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }
}

@media (max-width: 768px) {
  .logo-link {
    font-size: 1.5rem;
  }
}

@media (max-width: 576px) {
  .header-content {
    padding: 0.5rem 0;
  }

  .logo-link {
    font-size: 1.3rem;
  }
}
</style>